import TagManager from 'react-gtm-module'

export const gaQuiz = (_status, _score, _attempt) => {
    console.log(`quiz_status: ${_status} - quiz_score: ${_score} - quiz_attempts: ${_attempt}`)
    const tagManagerArgs = {
        dataLayer: {
            event: 'quiz',
            quiz_status: _status,
            quiz_score: _score,
            quiz_attempt: _attempt
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);
};

export const gaAudio = (_audioevent, _audiofile) => {
    console.log(`audioPlayerAction: ${_audioevent} - audio_file: ${_audiofile}`)
    const tagManagerArgs = {
        dataLayer: {
            event: 'audio',
            audioPlayerAction: _audioevent,
            audioTitle: _audiofile
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);

};

export const gaAudioProgress = (_percent, _audiofile) => {
    console.log(`audio_percent: ${_percent} - audio_title: ${_audiofile}`)
    const tagManagerArgs = {
        dataLayer: {
            event: 'audio',
            audioPlayerAction: 'Progress %' + _percent,
            audio_percent: _percent,
            audio_provider: "react-h5-audio-player",
            audioTitle: _audiofile
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);

};

export const gaButtonClick = (_event, _action, _label) => {
    const tagManagerArgs = {
        dataLayer: {
            event: _event,
            action: _action,
            label: _label
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);
    
};

export const gaPDFDownload = (_filename, _fileurl) => {
    console.log(`event: file_download - file_extension: pdf - file_name: ${_filename} - file_url: ${_fileurl}`)
    const tagManagerArgs = {
        dataLayer: {
            event: 'file_download',
            file_extension: 'pdf',
            file_name: _filename,
            file_url: _fileurl
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);
};

